import { Animation } from '@ionic/core';
import {
  createAnimation,
  DURATION_SHORT_4,
  EASING_EMPHASIZED_ACCELERATE,
  fadeOut,
  slideIn,
} from '../../../utils/animations';

export function sidebarCloseAnimation(
  sidebarElement: HTMLElement,
  backdropElement: HTMLElement,
  orientation: 'left' | 'right' = 'left',
): Animation {
  const sidebarAnim = createAnimation();

  const sidebarScale = slideIn(orientation)
    .duration(DURATION_SHORT_4)
    .addElement(sidebarElement)
    .easing(EASING_EMPHASIZED_ACCELERATE)
    .direction('reverse');
  const backdropFade = fadeOut()
    .duration(DURATION_SHORT_4)
    .addElement(backdropElement)
    .easing(EASING_EMPHASIZED_ACCELERATE);

  sidebarAnim.addAnimation(backdropFade);
  sidebarAnim.addAnimation(sidebarScale);
  return sidebarAnim;
}
